<template>
  <div>
    <b-modal
      :id="modalId"
      size="lg"
      :title="title"
      @ok="onSave"
      @show="updateData"
    >
    {{ formData.image }}
      <b-form-group label="Название">
        <b-form-input required v-model="formData.title" />
      </b-form-group>
      <b-form-group label="Описание">
        <b-form-textarea v-model="formData.data.description" />
      </b-form-group>
      <b-form-group label="Требования для кандидата">
        <b-form-textarea v-model="formData.data.requirementsForApplicant" />
      </b-form-group>
      <b-form-group label="Должностные обязанности">
        <b-form-textarea v-model="formData.data.requirements" />
      </b-form-group>
      <b-form-group label="Условия работы">
        <b-form-textarea v-model="formData.data.conditions" />
      </b-form-group>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button @click="ok" variant="primary" :disabled="isDisabled">
          Сохранить
        </b-button>
        <b-button @click="cancel" variant="outline-primary"> Отмена </b-button>
      </template>
      <b-form-group>
        <b-form-file
          ref="image-input"
          @change="loadFile($event.target, 'img')"
          multiple
          accept="image/jpeg, image/png"
        />
        <div v-for="(file, index) in getProfessionFile('img')" :key="index">
          <div v-if="!formData.delete.img.find(d => d === file.id)">
            {{ file.name }}
            <div
              class="fas fa-times text-danger mr-1"
              @click="setDeleteOption('img', file.id)"
              style="cursor: pointer"
            ></div>
          </div>
        </div>

        <template v-slot:label>
          <div class="d-inline-block">
            <span style="vertical-align: middle">Изображение</span>
            <b-badge
              variant="primary"
              class="ml-1"
              style="vertical-align: middle"
              v-b-tooltip.hover
              title="Форматы - png или jpg (jpeg). Максимальный размер - 5MB."
            >
              <em class="fas fa-info"></em>
            </b-badge>
          </div>
        </template>
      </b-form-group>
      <b-form-group label="Видео">
        <!-- <b-form-file
          ref="video-input"
          @change="loadFile($event.target, 'video')"
          accept=".mp4"
          multiple
        />
        <div v-for="(file, index) in getProfessionFile('video')" :key="index">
          <div v-if="!formData.delete.img.find(d => d === file.id)">
            {{ file.name }}
            <div
              class="fas fa-times text-danger mr-1"
              @click="setDeleteOption('video', file.id)"
              style="cursor: pointer"
            ></div>
          </div>
        </div> -->
        <div class="d-flex">
          <b-form-input v-model="videoUrl"/>
          <b-button variant="primary" @click="() => {videoUrl !== '' && formData.data.videosUrls.push(videoUrl); videoUrl=''}">Добавить</b-button>
        </div>
        <div v-for="(url, index) in formData.data.videosUrls" :key="index">
          <div>
            {{ url }}
            <div
              class="fas fa-times text-danger mr-1"
              @click="removeUrl(url)"
              style="cursor: pointer"
            ></div>
          </div>
        </div>
      </b-form-group>
      <b-form-group label="Презентация">
        <b-form-file
          ref="pdf-input"
          @change="loadFile($event.target, 'pdf')"
          v-if="!(getProfessionFile('pdf') && !formData.delete.pdf)"
          accept=".pdf"
        />
        <div v-else>
          {{ getProfessionFile('pdf').name }}
          <div
            class="fas fa-times text-danger mr-1"
            @click="setDeleteOption('pdf')"
            style="cursor: pointer"
          ></div>
        </div>
        <template v-slot:label>
          <div class="d-inline-block">
            <span style="vertical-align: middle">Презентация</span>
            <b-badge
              variant="primary"
              class="ml-1"
              style="vertical-align: middle"
              v-b-tooltip.hover
              title="Формат pdf. Максимальный размер - 5MB."
            >
              <em class="fas fa-info"></em>
            </b-badge>
          </div>
        </template>
      </b-form-group> 
      <b-form-group label="Пол">
        <b-form-select v-model="formData.gender" :options="genderOptions" />
      </b-form-group>
      <b-form-group label="Гражданство">
        <MultiSelect
          :value="formData.citizenship"
          :multiple="true"
          :options="citizenshipOptions"
          @input="onSelectCitizenship"
          label="text"
          trackBy="value"
        />
      </b-form-group>
      <b-form-group label="Направления обучения">
        <MultiSelect
          :value="formData.educationDirections"
          :multiple="true"
          :options="selectOptions.directions"
          @input="onSelectDirections"
          label="codeTitle"
          trackBy="code"
        />
      </b-form-group>
      <b-form-group label="Подразделение">
        <RawMultiselect
          v-model="formData.organization"
          :options="selectOptions.subdivisions"
          label="title"
          trackBy="id"
          placeholder="Выберите вариант"
          selectLabel="Нажмите enter, чтобы выбрать"
          deselectLabel="Нажмите enter, чтобы удалить"
        />
      </b-form-group>
      <b-button @click="showRangeModal">Выбрать вузы</b-button>
      <div>
        <RangeUniversitiesModal
          :isEdit="isEdit"
          style="z-index: 30"
          :editData="formData"
          @save="onRangeSave"
        >
        </RangeUniversitiesModal>
      </div>
    </b-modal>
  </div>
</template>

<script>
import COUNTRIES from '@/components/helpers/countries-to-select.json'
import RecommendationAPI from '@/api/recommendation'
import MultiSelect from '@/components/ui/MultiSelect.vue'
import _ from 'lodash'
import RangeUniversitiesModal from '@/components/admin/modals/recommendations/RangeUniversitiesModal.vue'
import { mapActions } from 'vuex'
import OrganizationAPI from '@/api/organization'
import RawMultiselect from 'vue-multiselect'
import WysiwygTextEditor from '@/components/content/edit/WysiwygTextEditor.vue'

export default {
  name: 'EditProfessionModal',
  components: {
    MultiSelect,
    RangeUniversitiesModal,
    RawMultiselect,
    WysiwygTextEditor,
  },
  props: {
    editData: {
      type: Object,
      default: null,
    },
    modalId: {
      type: String,
      default: 'editProfessionModal',
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    editData: {
      deep: true,
      handler() {
        this.updateData()
      },
    },
  },
  data() {
    return {
      title: '',
      editTitle: 'Редактирование профессии',
      addTitle: 'Добавление профессии',
      genderOptions: [
        { value: null, text: 'Любой' },
        { value: 'm', text: 'М' },
        { value: 'f', text: 'Ж' },
      ],
      citizenshipOptions: COUNTRIES,
      formData: {
        title: '',
        data: {
          description: '',
          requirementsForApplicant: '',
          requirements: '',
          conditions: '',
          videosUrls: []
        },
        image: [],
        video: null,
        presentation: null,
        gender: null,
        citizenship: [],
        educationDirections: [],
        delete: { 
          img: [], 
          video: [], 
          pdf: false },
        universitiesToShow: [],
        hiddenUniversities: [],
        organization: [],
      },
      selectOptions: {
        directions: [],
        subdivisions: [],
      },
      rangeWasOpened: false,
      videoUrl: ''
    }
  },
  async created() {
    await this.getDirections()
    await this.getSubdivisions()
  },
  computed: {
    isDisabled() {
      return !(
        this.formData.title &&
        this.formData.data.description &&
        this.formData.organization
      )
    },
  },

  methods: {
    ...mapActions({
      pushToasts: 'toasts/pushToasts',
    }),
    setDeleteOption(type, index) {
      this.formData.delete[type].push(index) // = index
      this.formData = _.cloneDeep(this.formData)
    },
    getProfessionFile(type) {
      const files = []
      if (this.formData.files) {
        for (const file of this.formData.files) {
          if (file.type === type) files.push(file)
          //return file;
        }
      }
      console.log(files)
      if (files.length) {
        return files
      }
      return null
    },
    async getSubdivisions() {
      this.selectOptions.subdivisions = (
        await OrganizationAPI.getSubdivisions()
      ).data
    },
    updateData() {
      if(this.editData && !this.editData.data.videosUrls) { //ужасный костыль
        this.editData.data.videosUrls = []
      }
      this.formData = _.cloneDeep(this.editData) || this.clearData()

      this.formData.delete = {
        img: [],
        video: [],
        pdf: false
      }
      this.title = this.editData ? this.editTitle : this.addTitle
      this.formData.citizenship = this.formData.citizenship.map((d) => ({
        value: d,
        text: this.citizenshipOptions.find((r) => r.value === d).text,
      }))
    },
    async onSave() {
      const tmpFormData = _.cloneDeep(this.formData)
      if (tmpFormData.universitiesToShow === null) {
        const partners = (await RecommendationAPI.getUniversities()).data
        tmpFormData.universitiesToShow = partners
      }
      tmpFormData.citizenship = tmpFormData.citizenship.map((d) => d.value)
      console.log(tmpFormData)
      this.$emit('save', tmpFormData)
      this.rangeWasOpened = false
    },
    onRangeSave(data) {
      this.formData.universitiesToShow = data.universitiesToShow
      this.formData.hiddenUniversities = data.hiddenUniversities
    },
    clearData() {
      return {
        title: '',
        data: {
          description: '',
          requirementsForApplicant: '',
          requirements: '',
          conditions: '',
          videosUrls: []
        },
        image: null,
        video: null,
        presentation: null,
        gender: null,
        citizenship: [],
        educationDirections: [],
        delete: { img: [], video: [], pdf: false },
        universitiesToShow: null,
        
      }
    },
    removeUrl(url) {
      console.log(this.formData.data.videosUrls, url)
      this.formData.data.videosUrls = this.formData.data.videosUrls.filter((d) => d !== url)
    },
    async getDirections() {
      const directions = await RecommendationAPI.getDirectionsByGroup()
      this.selectOptions.directions = _.sortBy(directions.data, 'code').map(
        (dg) => ({ ...dg, codeTitle: `${dg.code} ${dg.title}` })
      )

      this.updateData()
    },
    onSelectDirections(obj) {
      this.formData.educationDirections = obj
    },
    showRangeModal() {
      this.rangeWasOpened = true
      this.$bvModal.show('range-university-modal')
    },
    onSelectCitizenship(obj) {
      this.formData.citizenship = obj
    },
    loadFile(input, type) {
      if (!input.files[0]) {
        if (type === 'img') {
          this.formData.image = null
          return
        } else if (type === 'video') {
          this.formData.video = null
          return
        } else if (type === 'pdf') {
          this.formData.presentation = null
          return
        }
      }
      if (type === 'img') {
        if (
          input.files[0].type.split('/')[0] !== 'image' ||
          !['jpg', 'png', 'jpeg'].includes(input.files[0].type.split('/')[1])
        ) {
          this.pushToasts({
            title: 'Уведомление',
            error: true,
            message: `При загрузке возникла ошибка. Файл: ${input.files[0].name} не был загружен в связи с несоответствием типа!`,
          })
          this.$refs['image-input'].reset()
          this.formData.image = null
        } else if (input.files[0].size / 1024 / 1024 > 5) {
          this.pushToasts({
            title: 'Уведомление',
            error: true,
            message: `При загрузке возникла ошибка. Файл:${input.files[0].name} не был загружен в связи с превышением максимального размера!`,
          })
          this.$refs['image-input'].reset()
          this.formData.image = null
        } else {
          this.formData.image = input.files
          console.log(input.files)
        }
      } else if (type === 'video') {
        if (!['mp4', 'MP4'].includes(input.files[0].type.split('/')[1])) {
          this.pushToasts({
            title: 'Уведомление',
            error: true,
            message: `При загрузке возникла ошибка. Файл: ${input.files[0].name} не был загружен в связи с несоответствием типа!`,
          })
          this.$refs['video-input'].reset()
          this.formData.video = null
        } else if (input.files[0].size / 1024 / 1024 > 10) {
          this.pushToasts({
            title: 'Уведомление',
            error: true,
            message: `При загрузке возникла ошибка. Файл:${input.files[0].name} не был загружен в связи с превышением максимального размера!`,
          })
          this.$refs['video-input'].reset()
          this.formData.video = null
        } else {
          this.formData.video = input.files
        }
      } else if (type === 'pdf') {
        if (!['pdf', 'PDF'].includes(input.files[0].type.split('/')[1])) {
          this.pushToasts({
            title: 'Уведомление',
            error: true,
            message: `При загрузке возникла ошибка. Файл: ${input.files[0].name} не был загружен в связи с несоответствием типа!`,
          })
          this.$refs['pdf-input'].reset()
          this.formData.presentation = null
        } else if (input.files[0].size / 1024 / 1024 > 5) {
          this.pushToasts({
            title: 'Уведомление',
            error: true,
            message: `При загрузке возникла ошибка. Файл:${input.files[0].name} не был загружен в связи с превышением максимального размера!`,
          })
          this.$refs['pdf-input'].reset()
          this.formData.presentation = null
        } else {
          this.formData.presentation = input.files[0]
        }
      }
    },
  },
}
</script>

<style scoped>
.ag-grid-olympics-list {
  height: calc(100vh - 600px);
  min-height: 250px;
}

.ghost > .item-child {
  background-color: rgba(0, 0, 0, 0.2) !important;
}

.multiselect__tags {
  background-color: aqua;
}
</style>

<style>
.ms-in-edit-prof-modal > .multiselect__tag-icon {
  background-color: red !important;
}

.range-modal .modal-dialog {
  width: auto !important;
  max-width: 960px !important;
}
</style>